import React from 'react';
import {Row, Col} from 'react-flexbox-grid';
import './Home.scss';
import CentredContent from '../../components/CentredContent/CentredContent';
import Spacer from '../../components/Spacer/Spacer';
import SmartImageContainer from '../../components/SmartImageContainer/SmartImageContainer';
import Portrait from '../../components/Portrait/Portrait'


class Home extends React.Component {
    render() {
        return (
            <div className="home-page">
                <div className="atf">
                    <CentredContent>
                        <Row>
                            <Col xs={6} xsOffset={3} sm={3} smOffset={0}>
                                <div className="atf-logo">
                                    <img src="img/logo-ombra.png" alt="Emanuele Lena Sviluppo Software"></img>
                                </div>
                            </Col>
                            <Col xs={12} xsOffset={0} sm={8} smOffset={1}>
                                <div className="atf-title">
                                    <h1>Emanuele Lena</h1>
                                    <h2>
                                        Software Engineer, Laureato magistrale in Informatica
                                    </h2>
                                </div>
                            </Col>
                        </Row>
                    </CentredContent>
                </div>

                <div className="projects-categories-bar">
                    <div className="project-category">
                        <SmartImageContainer src="img/progetti/uniud-sailing-lab.jpg" href="/progetti-vari" alt="progetti personali sviluppo software" title="Vedi Altri Progetti">
                            <h2 className="category-name">Progetti personali</h2>
                            {/* TODO: add subtitle */}
                            <h3 className='category-description'>
                                Progetti personali e universitari
                            </h3>
                        </SmartImageContainer>
                    </div>

                    <div className="project-category">
                        <SmartImageContainer src="img/progetti/sito-responsive.png" href="/siti-web" alt="portfolio siti web" title="Vedi Portfolio Siti Web" >
                            <h2 className="category-name">Siti Web</h2>
                            {/* TODO: add subtitle */}
                            <h3 className='category-description'>
                                Siti web sviluppati<br/>
                                come libero professionista
                            </h3>
                        </SmartImageContainer>
                    </div>
                </div>

                <Spacer height="50px"></Spacer>

                <div className="about-me-short">
                    <CentredContent>
                        <Row>
                            <Col xs={12} sm={4}>
                                <div className="about-me-short-picture">
                                    <Portrait src={"/img/profilo-nuova.jpg"} alt="Emanuele Lena Sviluppo Web" title="Questo sono io">
                                    </Portrait>
                                </div>
                            </Col>
                            <Col xs={12} sm={8}>
                                <div className="about-me-short-description">
                                    <div className="about-me-short-description-content">
                                        <h3>Qualcosa su di me (in breve)</h3>
                                        <ul>
                                            <li>
                                                <strong>Chi sono:</strong> mi chiamo Emanuele.
                                            </li>
                                            <li>
                                                <strong>Cosa ho studiato:</strong> sono laureato triennale e 
                                                magistrale all'Università degli Studi di Udine
                                                in <a href="https://www.uniud.it/it/didattica/corsi/area-scientifica/scienze-matematiche-informatiche-multimediali-fisiche/laurea/internet-of-things-big-data-web/corso/internet-of-things-big-data-web"
                                                target='_blank' rel="noreferrer">
                                                Internet of Things, 
                                                Big Data & Web</a> e <a 
                                                href="https://www.uniud.it/it/didattica/info-didattiche/piano-di-studio/laurea-magistrale-informatica/2021-2022#autotoc-item-autotoc-4"
                                                target="_blank" rel="noreferrer">Informatica
                                                </a> (<em>entrambe le lauree 
                                                conseguite in corso
                                                e con voto <strong>110L</strong></em>).
                                            </li>
                                            <li>
                                                <strong>Che cosa so fare:</strong>
                                                <ul>
                                                    <li>
                                                        sviluppo e testing automatizzato di software
                                                        (prevalentemente in ambito sistemi distribuiti e intelligenza artificiale,
                                                        linguaggio principale: Python);
                                                    </li>
                                                    <li>
                                                        analisi e progettazione di software (UML, Use Cases, Impact Mapping, design pattern, refactoring);
                                                    </li>
                                                    <li>
                                                        realizzazione di sistemi di intelligenza artificiale, in particolare basati su Large Language Model (LLM) e Retrieval-Augmented Generation (RAG);
                                                    </li>
                                                    <li>
                                                        analisi dei dati, data mining e machine learning.
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <strong>Che cosa faccio adesso:
                                                </strong> attualmente, lavoro
                                                come <em>software engineer
                                                </em> presso <a
                                                href='https://designcoaching.net/' target='_blank' rel="noreferrer">IDS Srl</a>.
                                            </li>
                                        </ul>
                                        <Spacer height="20px"></Spacer>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <h3>Formazione</h3>

                        <p>
                            A ottobre 2021 ho completato la 
                            laurea triennale in <a
                            href="https://www.uniud.it/it/didattica/corsi/area-scientifica/scienze-matematiche-informatiche-multimediali-fisiche/laurea/internet-of-things-big-data-web/corso/internet-of-things-big-data-web"
                            target='_blank' rel="noreferrer">Internet of Things, 
                            Big Data & Web</a> con una 
                            tesi sullo <a href="/progetti-vari/uniud-sailing-lab-neptune-2-0"
                            title="Progettazione e sviluppo di Neptune 2.0">sviluppo di un software per 
                            l'assistenza alla navigazione a vela</a> prendendo
                            il massimo dei voti (<strong>110L</strong>)
                            e venendo riconosciuto come il miglior studente del
                            mio corso per il mio anno di laurea.
                        </p>
                        <p>
                            Sempre a ottobre 2021 ho iniziato la laurea
                            magistrale in Informatica, scegliendo la
                            specializzazione in <a 
                            href="https://www.uniud.it/it/didattica/info-didattiche/piano-di-studio/laurea-magistrale-informatica/2021-2022#autotoc-item-autotoc-4"
                            target="_blank" rel="noreferrer">Progetto e Sviluppo Software</a>.
                            Durante questi due anni ho avuto modo di approfondire
                            - sia con lo studio teorico che
                            con <a href="/progetti-vari/"
                            title="Progetti pratici vari">progetti pratici
                            e/o di ricerca</a> temi come:
                        </p>
                        <ul>
                        <li>
                            la progettazione e lo sviluppo di software, 
                            in particolare con il paradigma Object-Oriented
                            (ma anche con qualche accenno allo stile funzionale),
                            studiando - tra le varie cose - i design pattern,
                            la modellazione UML, il refactoring, 
                            la qualità del codice, il testing automatizzato
                            e i sistemi distribuiti;
                        </li>
                        <li>
                            la gestione del processo di sviluppo software
                            con metodologie AGILE (SCRUM) e la visione del problema
                            da prospettive anche non stettamente tecniche
                            (Informatica e Diritto, Sistemi Informativi e Data Warehouse, Ingegneria del Software);
                        </li>
                        <li>
                            l'analisi dei dati, partendo da Probabilità e Statistica e arrivando ai Large Language Models (LLM),
                            passando per l'Algebra Lineare, il Natural Language Processing (NLP), lo studio dei grafi e il machine learning;
                        </li>
                        <li>
                            la realizzazione e la valutazione di sistemi basati
                            su dati e/o modelli di machine learning (e.g., <em>
                            Information Retrieval</em>, <em>
                            Recommender Systems</em>).
                        </li>
                        </ul>
                        <p>
                            A marzo 2024 mi sono laureato - <em>
                            con voto <strong>110L</strong></em> - portando 
                            una tesi in <a href="/progetti-vari/tesi-magistrale-machine-learning-software-testing"
                            title='Tesi di laurea Magistrale - Data Mining su Rapporti
                            di Test di Sistema del Software
                            usando Machine Learning e
                            Large Language Model'>machine learning
                            e Large Language Model applicati ai dati dei rapporti
                            di test di sistema del software</a>.
                        </p>
                        <h3>Esperienze lavorative</h3>
                        <h4>Libero professionista (2020-2024)</h4>
                        <p>
                            Durante i miei studi ho lavorato come libero professionista
                            nell'ambito dello sviluppo web. Nel corso di questa
                            esperienza mi sono occupato di 
                            progettare e realizzare siti web per piccole-medie aziende,
                            svolgendo in autonomia sia la realizzazzione tecnica
                            anche le attività di progettazione,
                            rapporto con il cliente e analisi dei requisiti.
                        </p>
                        <h4>Software Engineer presso IDS Srl (2024-oggi)</h4>
                        <p>
                            Da aprile 2024 lavoro
                            come <em>software engineer</em> presso la società 
                            di consulenza <a href='https://designcoaching.net/'
                            target='_blank' rel="noreferrer">Interaction Design Solutions Srl (IDS Srl)</a>.
                        </p>
                        <p>
                            Sin dalla mia assunzione sono stato inserito
                            in <a href='https://www.skao.int/'
                            target='_blank' rel="noreferrer">SKAO</a>, ovvero il progetto internazionale
                            di costruzione del più grande radiotelescopio del mondo. In questo contesto,
                            mi occupo principalmente di testing di integrazione automatizzato.
                            Sono attualmente principal developer di librerie per il testing di sistemi distribuiti basati sul
                            framework <a href='https://tango-controls.readthedocs.io/projects/pytango/en/stable/' target='_blank' rel="noreferrer">
                            Tango/PyTango</a>. Siccome il codice SKA ha una licenza <em>BSD a 3 clausole</em>,
                            il mio lavoro (codice, merge requests, documentazione, ecc.) è visibile pubblicamente
                            su <a href='https://gitlab.com/EmanueleIDS' target='_blank' rel="noreferrer">GitLab</a>.
                        </p>
                        <p>
                            Sempre nel contesto SKAO, ho collaborato (in qualità di co-autore)
                            ad attività di ricerca sull'analisi dei dati di test di sistema
                            (<a href="https://www.researchgate.net/publication/382566882_Enhancing_SKA_software_testing_through_data_mining_strategies" target="_blank" rel="noreferrer">
                            pubblicazione su ResearchGate</a>).
                        </p>
                        <p>
                            Oltre a SKAO, ho lavorato e lavoro tuttora sullo sviluppo
                            di assistenti AI. In particolare, mi sono occupato di sistemi
                            basati su LLM (sia open-source che proprietari),
                            information retrieval (RAG), architetture ad agenti,
                            tooling per la manipolazione di dati strutturati
                            e pipeline di estrazione e indicizzazione di documenti complessi.
                        </p>
                        <p>
                            Per concludere, ho partecipato saltuariamente ad attività di
                            consulenza, coaching e formazione assieme ai miei titolari.
                            In particolare,
                        </p>
                        <ul>
                            <li>
                                ho tenuto corsi di formazione e sessioni di coaching
                                su Github Copilot e sull'impatto dell'AI generativa sullo sviluppo software;
                            </li>
                            <li>
                                ho partecipato ad attività di analisi del debito tecnico.
                            </li>
                        </ul>
                    </CentredContent>
                </div>

                <Spacer height="50px"></Spacer>
            </div>
        );
    }
}

export default Home;